module.exports = __webpack_public_path__ + "static/media/caret-circle-down.cdf44237.svg";